import { authGet } from "@api";

import { PolicyAllRulesYaml } from "@pages/policy/types";

export const fetchRulesYamlFromPolicy = (
  deploymentId: string,
  policySlug: string
): Promise<PolicyAllRulesYaml> => {
  const path = `/api/agent/deployments/${deploymentId}/policies/${policySlug}/rules`;
  return authGet<PolicyAllRulesYaml>(path);
};
